export enum Resolution {
  Second = 'Second',
  Minute = 'Minute',
  Hourly = 'Hourly',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly'
}
